import { gsap } from "../../_Global/js/global";

document.addEventListener('DOMContentLoaded', () => {
    const landingHeader = document.querySelector('.landingHeader');

    if(landingHeader) {
        const landingHeaderBlocks = landingHeader.querySelectorAll('.landingHeaderBlock');
        const landingHeaderLines = landingHeader.querySelectorAll('.landingHeaderLines');

    	const timeline = gsap.timeline();

        timeline.fromTo(landingHeaderLines, {
            opacity: 0,
            x: '100%'
        }, {
            duration: 1,
            opacity: 1,
            x: 0,
            ease: 'power1.out',
        });

        if(landingHeaderBlocks) {
            landingHeaderBlocks.forEach((item, index) => {
                timeline.fromTo(item, {
                    opacity: 0,
                    y: '100px'
                }, {
                    duration: 1,
                    opacity: 1,
                    y: 0,
                    ease: 'power1.out',
                }, index * 0.2);
            });  
        }
    }
});